import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  VoucherService,
  buildTransaction,
  saveVoucher,
  clearVoucher
} from '../normalizer'

class VoucherContainer extends Component {
  voucherId = () => this.props.match.params.id

  // The action handlers return the raw service promise so the confirmation
  // modal can drive its own success/error state machine from the response.
  handleReorder = () => VoucherService.activateVoucher({ id: this.voucherId() })

  handleArchive = () => VoucherService.archiveVoucher({ id: this.voucherId() })

  handleGoHome = () => {
    this.props.history.push('/wallet')
  }

  // The endpoint wraps the voucher under a key named after its own path
  // (e.g. "user/voucher"), the same convention WalletContainer already
  // normalises for the list/pills endpoints. Fall back to the raw payload
  // when it isn't wrapped so older/other shapes still work.
  extractVoucher = (data) => {
    if (!data || typeof data !== 'object') return null
    if (data.voucher) return data.voucher
    if (data['user/voucher']) return data['user/voucher']
    return data
  }

  // Always fetch the full voucher from its own endpoint instead of relying
  // on the row data passed from the /wallet table, so this page shows
  // complete, up-to-date data (e.g. terms_text, product) on direct access too.
  getVoucher = () => {
    const id = this.voucherId()
    if (!id) return
    VoucherService.getVoucher(id)
      .then((response) => this.props.saveVoucher(this.extractVoucher(response.data)))
      .catch(() => null)
  }

  componentDidMount() {
    this.getVoucher()
  }

  componentWillUnmount() {
    this.props.clearVoucher()
  }

  render() {
    const { component: Component, ...rest } = this.props
    return (
      <Component
        {...rest}
        onReorder={this.handleReorder}
        onArchive={this.handleArchive}
        onGoHome={this.handleGoHome}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  campaign: state.campaignReducer.campaign,
  user: state.userReducer.user,
  walletConfig: state.walletReducer.config,
  voucher: state.voucherReducer.selectedVoucher
})

const mapDispatchToProps = (dispatch) => ({
  startTransaction: buildTransaction(dispatch),
  saveVoucher: (voucher) => dispatch(saveVoucher(voucher)),
  clearVoucher: () => dispatch(clearVoucher())
})

const Container = withRouter(connect(mapStateToProps, mapDispatchToProps)(VoucherContainer))

export function withVoucherContainer(component) {
  return (props) => (
    <Container
      component={component}
      {...props}
    />
  )
}

export default Container
